import { gateway } from '../../../gateway';

/**
 * Action to delete an existing todo task
 *
 * Backend endpoint: DELETE /todo-tasks/self/:taskUid
 * Response format: { status: 200, message: "Todo task deleted", data: true }
 */
export const deleteTodoTaskAction = async (taskId: string): Promise<void> => {
  try {
    if (!taskId) {
      throw new Error('Task ID is required');
    }

    await gateway.delete(`/todo-tasks/self/${taskId}`);
  } catch (error: any) {
    console.error('Error deleting todo task:', error);
    const errorMessage =
      error?.response?.data?.message || error?.message || 'Failed to delete todo task';
    throw new Error(errorMessage);
  }
};
